import Messages from './messages';
import Campaigns from './campaigns';
import Reports from './reports';

export default ($axios) => ({
  messages: Messages($axios),
  campaigns: Campaigns($axios),
  reports: Reports($axios),
});
